import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import { AdminLayout } from "./components/AdminLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LoginPage } from "./features/auth/LoginPage";
import { SociosListPage } from "./features/socios/SociosListPage";
import { CuentaCorrienteSocioPage } from "./features/socios/CuentaCorrienteSocioPage";
import { CierresListPage } from "./features/cierres/CierresListPage";
import { CierreDetailPage } from "./features/cierres/CierreDetailPage";
import { DocumentosSiiPage } from "./features/dte/DocumentosSiiPage";
import { CierreProformaPage } from "./features/cierres/CierreProformaPage";
import { LecturasListPage } from "./features/lecturas/LecturasListPage";
import { ConsumosPage } from "./features/consumos/ConsumosPage";
import { AnalisisConsumoPage } from "./features/analisis/AnalisisConsumoPage";
import { CortesListPage } from "./features/cortes/CortesListPage";
import { CajaPage } from "./features/caja/CajaPage";
import { EntregasPage } from "./features/entregas/EntregasPage";
import { MorosidadPage } from "./features/morosidad/MorosidadPage";
import { CorteDetailPage } from "./features/cortes/CorteDetailPage";
import { MultasListPage } from "./features/multas/MultasListPage";
import { SubsidiosListPage } from "./features/subsidios/SubsidiosListPage";
import { OrganismosPage } from "./features/subsidios/OrganismosPage";
import { RendicionPage } from "./features/subsidios/RendicionPage";
import { TarifasListPage } from "./features/tarifas/TarifasListPage";
import { TarifaDetailPage } from "./features/tarifas/TarifaDetailPage";
import { AsambleasListPage } from "./features/asambleas/AsambleasListPage";
import { AsambleaDetailPage } from "./features/asambleas/AsambleaDetailPage";
import { RutaDetailPage } from "./features/rutas/RutaDetailPage";
import { RutasListPage } from "./features/rutas/RutasListPage";
import { SectoresListPage } from "./features/sectores/SectoresListPage";
import { ArranquesListPage } from "./features/arranques/ArranquesListPage";
import { MedidoresListPage } from "./features/arranques/MedidoresListPage";
import { ContratosListPage } from "./features/contratos/ContratosListPage";
import { EmpresaDetailPage } from "./features/superadmin/EmpresaDetailPage";
import { EmpresasListPage } from "./features/superadmin/EmpresasListPage";
import { EmpresaUsuariosPage } from "./features/superadmin/EmpresaUsuariosPage";
import { RolesListPage } from "./features/superadmin/RolesListPage";
import { SuperadminGate } from "./features/superadmin/SuperadminGate";
import { AuditLogPage } from "./features/audit/AuditLogPage";
import { AtencionesListPage } from "./features/atenciones/AtencionesListPage";
import { ContinuidadPage } from "./features/continuidad/ContinuidadPage";
import { BodegaPage } from "./features/inventario/BodegaPage";
import { InsumosListPage } from "./features/inventario/InsumosListPage";
import { ProveedoresListPage } from "./features/inventario/ProveedoresListPage";
import { ActivosListPage } from "./features/mantenimiento/ActivosListPage";
import { OrdenesTrabajoPage } from "./features/mantenimiento/OrdenesTrabajoPage";
import { PlanesMantenimientoPage } from "./features/mantenimiento/PlanesMantenimientoPage";
import { SolicitudesComprasPage } from "./features/compras/SolicitudesComprasPage";
import { OrdenesCompraPage } from "./features/compras/OrdenesCompraPage";
import { ConfiguracionComprasPage } from "./features/compras/ConfiguracionComprasPage";
import { ReajustesListPage } from "./features/reajustes/ReajustesListPage";
import { DashboardPage } from "./features/dashboard/DashboardPage";
import { InicioPage } from "./features/dashboard/InicioModulosPage";
import { BalancePage } from "./features/contabilidad/BalancePage";
import { CargasPage } from "./features/contabilidad/CargasPage";
import { CuentasPorMesPage } from "./features/contabilidad/CuentasPorMesPage";
import { DiarioPage } from "./features/contabilidad/DiarioPage";
import { InicioContablePage } from "./features/contabilidad/InicioContablePage";
import { MayorPage } from "./features/contabilidad/MayorPage";
import { PlanCuentasPage } from "./features/contabilidad/PlanCuentasPage";
import { MiClavePage } from "./features/auth/MiClavePage";
import { ConfiguracionPage } from "./features/empresa/ConfiguracionPage";

export function App(): JSX.Element {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  if (isLoginPage) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<InicioPage dashboard={<DashboardPage />} />} />
        <Route path="/socios" element={<SociosListPage />} />
        <Route
          path="/socios/:socioId/cuenta-corriente"
          element={<CuentaCorrienteSocioPage />}
        />
        <Route path="/lecturas" element={<LecturasListPage />} />
        <Route path="/consumos" element={<ConsumosPage />} />
        <Route path="/analisis-consumo" element={<AnalisisConsumoPage />} />
        <Route path="/cierres" element={<CierresListPage />} />
        <Route path="/cierres/:cierreId" element={<CierreDetailPage />} />
        <Route path="/documentos-sii" element={<DocumentosSiiPage />} />
        <Route
          path="/cierres/:cierreId/proforma"
          element={<CierreProformaPage />}
        />
        <Route path="/cortes" element={<CortesListPage />} />
        <Route path="/morosidad" element={<MorosidadPage />} />
        <Route path="/caja" element={<CajaPage />} />
        <Route path="/entregas" element={<EntregasPage />} />
        <Route path="/cortes/:ordenId" element={<CorteDetailPage />} />
        <Route path="/multas" element={<MultasListPage />} />
        <Route path="/subsidios" element={<SubsidiosListPage />} />
        <Route path="/subsidios/organismos" element={<OrganismosPage />} />
        <Route path="/subsidios/rendicion" element={<RendicionPage />} />
        <Route path="/tarifas" element={<TarifasListPage />} />
        <Route path="/tarifas/:tarifaId" element={<TarifaDetailPage />} />
        <Route path="/asambleas" element={<AsambleasListPage />} />
        <Route
          path="/asambleas/:reunionId"
          element={<AsambleaDetailPage />}
        />
        <Route path="/sectores" element={<SectoresListPage />} />
        <Route path="/rutas" element={<RutasListPage />} />
        <Route path="/rutas/:id" element={<RutaDetailPage />} />
        <Route path="/arranques" element={<ArranquesListPage />} />
        <Route path="/medidores" element={<MedidoresListPage />} />
        <Route path="/contratos" element={<ContratosListPage />} />
        <Route path="/atenciones" element={<AtencionesListPage />} />
        <Route path="/continuidad" element={<ContinuidadPage />} />
        <Route path="/contabilidad" element={<InicioContablePage />} />
        <Route path="/contabilidad/balance" element={<BalancePage />} />
        <Route path="/contabilidad/cuentas-por-mes" element={<CuentasPorMesPage />} />
        <Route path="/contabilidad/mayor" element={<MayorPage />} />
        <Route path="/contabilidad/mayor/:cuentaId" element={<MayorPage />} />
        <Route path="/contabilidad/diario" element={<DiarioPage />} />
        <Route path="/contabilidad/cargas" element={<CargasPage />} />
        <Route path="/contabilidad/plan" element={<PlanCuentasPage />} />
        <Route path="/bodega" element={<BodegaPage />} />
        <Route path="/insumos" element={<InsumosListPage />} />
        <Route path="/proveedores" element={<ProveedoresListPage />} />
        <Route path="/activos" element={<ActivosListPage />} />
        <Route path="/ordenes-trabajo" element={<OrdenesTrabajoPage />} />
        <Route path="/planes-mantencion" element={<PlanesMantenimientoPage />} />
        <Route path="/compras/solicitudes" element={<SolicitudesComprasPage />} />
        <Route path="/compras/ordenes" element={<OrdenesCompraPage />} />
        <Route path="/compras/configuracion" element={<ConfiguracionComprasPage />} />
        <Route path="/reajustes" element={<ReajustesListPage />} />
        <Route path="/auditoria" element={<AuditLogPage />} />
        <Route path="/configuracion" element={<ConfiguracionPage />} />
        <Route path="/mi-clave" element={<MiClavePage />} />
        <Route
          path="/superadmin/empresas"
          element={
            <SuperadminGate>
              <EmpresasListPage />
            </SuperadminGate>
          }
        />
        <Route
          path="/superadmin/empresas/:empresaId"
          element={
            <SuperadminGate>
              <EmpresaDetailPage />
            </SuperadminGate>
          }
        />
        <Route
          path="/superadmin/empresas/:empresaId/usuarios"
          element={
            <SuperadminGate>
              <EmpresaUsuariosPage />
            </SuperadminGate>
          }
        />
        <Route
          path="/superadmin/roles"
          element={
            <SuperadminGate>
              <RolesListPage />
            </SuperadminGate>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
